import { render, staticRenderFns } from "./ProductPricingImportModal.vue?vue&type=template&id=6a956d56&scoped=true"
import script from "./ProductPricingImportModal.vue?vue&type=script&lang=js"
export * from "./ProductPricingImportModal.vue?vue&type=script&lang=js"
import style0 from "./ProductPricingImportModal.vue?vue&type=style&index=0&id=6a956d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a956d56",
  null
  
)

export default component.exports